export class TicketPrintReply {
  object = 'ticketPrintReply';
  ticketId: number;
  requestId: string;
  successFlag: boolean;
  responseMessage: string;
  sentToBatch: boolean;
}
